<template>
	<div class="product-header-container">
		<!-- 顶部菜单 Header（吸顶后隐藏） -->
		<div class="smart-header" v-show="!computedSticky">
			<Header theme="light" :showBorder="true" :backgroundColor="'#ffffff'" :iconColor="'black'"
				:smallLogoWidth="largeLogoWidth" :smallLogoHeight="largeLogoHeight"
				:smallLogoWidthShrink="smallLogoWidth" :smallLogoHeightShrink="smallLogoHeight" :borderVisible="false"
				:hideSideNav="isPhase1Complete" :logoShrink="isPhase1Complete" :isSticky="computedSticky"
				@menu-open="onMenuOpen" @menu-close="onMenuClose" />
		</div>

		<!-- 固定信息栏（位于 Header 下方） -->
		<div class="fixed-info-bar" :class="{ 'bar-hidden': computedSticky }">
			<div class="info-bar-inner">
				<div class="left-group">
					<h1 class="page-title">{{ productName }}</h1>
					<div class="page-description" v-if="productDescription">{{ productDescription }}</div>
				</div>
				<div class="right-group">
					<div style="height: 10rem;width: 100%;"></div>
					<div>
						<span class="product-count">{{ totalCount }} Products</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 吸顶条 -->
		<div class="sticky-bar" :class="{ 'is-visible': computedSticky }">
			<div class="sticky-bar-inner">
				<div class="left-group">
					<h1 class="sticky-title">{{ productName }}</h1>
				</div>
				<span class="sticky-count">{{ totalCount }} Products</span>
				<div class="sticky-logo" :class="{ 'logo-visible': computedSticky }">
					<img :src="logoBlack" alt="denHolm" class="sticky-logo-img" style="width: 150.4rem;height: auto;"
						@click="goToHome" />
				</div>
			</div>
		</div>

		<!-- 内容区域 -->
		<div class="content-wrapper" :style="contentWrapperStyle">
			<div class="content-spacer" style="transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);"></div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import Header from './Header.vue'
	import logoBlack from '../assets/logo_b.png'

	export default {
		name: 'ProductHeader',
		components: { Header },
		props: {
			totalCount: { type: Number, default: 0 },
			productName: { type: String, default: 'ALL Products' },
			productDescription: { type: String, default: 'All Product Displays' },
			smallLogoWidth: { type: Number, default: 118 },
			smallLogoHeight: { type: Number, default: 13 },
			largeLogoWidth: { type: Number, default: 188 },
			largeLogoHeight: { type: Number, default: 24 },
			// ★ 新增：外部控制是否吸顶（不传则内部自动计算）
			isSticky: { type: Boolean, default: undefined }
		},
		data() {
			return {
				menuOpen: false,
				logoBlack,
				isPhase1Complete: false,
				// 内部吸顶状态（仅在外部未传入时使用）
				internalSticky: false,
				lastScrollY: 0,
				ticking: false,
				stickyBarHeight: 76,
				headerHeight: 74,
				infoBarHeight: 80,
			}
		},
		computed: {
			// ★ 计算属性：优先使用外部传入的值
			computedSticky() {
				if (this.isSticky !== undefined) {
					return this.isSticky;
				}
				return this.internalSticky;
			},
			totalSpacerHeight() {
				return this.headerHeight + this.infoBarHeight
			},
			contentWrapperStyle() {
				const topPadding = this.computedSticky
					? this.stickyBarHeight + 'rem'
					: '289rem';
				return { paddingTop: topPadding };
			}
		},
		mounted() {
			// 仅当外部未传入 isSticky 时，才启用内部滚动监听
			if (this.isSticky === undefined) {
				window.addEventListener('scroll', this.handleScroll, { passive: true });
				this.$nextTick(() => this.updateState());
			} else {
				// 外部控制时，同步 internalSticky 以便后续可能切换（但实际不会用到）
				this.internalSticky = this.isSticky;
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		watch: {
			// 如果外部传入的值变化，同步内部状态（以备不时之需）
			isSticky(newVal) {
				if (newVal !== undefined) {
					this.internalSticky = newVal;
				}
			}
		},
		methods: {
			onMenuOpen() {
				this.menuOpen = true;
				this.$emit('menu-open')
			},
			onMenuClose() {
				this.menuOpen = false;
				this.$emit('menu-close')
			},
			goToHome() {
				this.$router.push({ name: 'Home' })
			},
			handleScroll() {
				if (!this.ticking) {
					window.requestAnimationFrame(() => {
						this.updateState()
						this.ticking = false
					})
					this.ticking = true
				}
			},
			updateState() {
				const currentScroll = window.pageYOffset || document.documentElement.scrollTop
				const delta = currentScroll - this.lastScrollY
				this.lastScrollY = currentScroll

				const threshold = 100
				const isDown = delta > 0
				const isUp = delta < 0

				if (currentScroll <= 80) {
					if (this.internalSticky) {
						this.internalSticky = false
						this.isPhase1Complete = false
					}
					return
				}

				if (isDown && currentScroll > threshold && !this.internalSticky) {
					this.internalSticky = true
					this.isPhase1Complete = true
				} else if (isUp && this.internalSticky) {
					this.internalSticky = false
					this.isPhase1Complete = false
				}
			}
		}
	}
</script>

<style scoped>
	/* 样式与您原来完全一致，未做修改 */
	.product-header-container {
		width: 100%;
		position: relative;
		background-color: #ffffff;
	}
	.smart-header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		background-color: #ffffff;
		transition: opacity 0.3s ease;
	}
	.fixed-info-bar {
		position: fixed;
		left: 0;
		width: 100%;
		z-index: 999;
		background-color: #ffffff;
		padding: 16rem 40rem;
		box-sizing: border-box;
		border-bottom: 1rem solid #000;
		transform: translateY(0);
		opacity: 1;
		transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
			opacity 0.3s ease;
		padding: 208rem 51rem 33rem 51rem;
	}
	.fixed-info-bar.bar-hidden {
		transform: translateY(-100%);
		opacity: 0;
		pointer-events: none;
	}
	.info-bar-inner {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	.left-group {
		flex: 1;
		min-width: 0;
	}
	.page-title {
		font-size: 16rem;
		font-weight: 500;
		color: #000;
		margin: 0 0 14rem 0;
		font-family: 'Apercu-Medium', sans-serif;
		height: 15rem;
		line-height: 15rem;
	}
	.page-description {
		font-size: 12rem;
		color: #000;
		font-weight: 500;
		margin: 0;
		line-height: 1.5;
		width: 470rem;
		font-family: 'Apercu-Medium', sans-serif;
	}
	.product-count {
		font-size: 12rem;
		font-weight: 500;
		color: #000;
		flex-shrink: 0;
		margin-left: 20rem;
		align-self: center;
		font-family: 'Apercu-Medium', sans-serif;
	}
	.sticky-bar {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background-color: #ffffff;
		padding: 16rem 40rem;
		box-sizing: border-box;
		z-index: 998;
		transform: translateY(-100%);
		transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
			padding 0.3s ease,
			box-shadow 0.3s ease,
			border-bottom 0.3s ease;
		border-bottom: none;
		box-shadow: none;
	}
	.sticky-bar.is-visible {
		transform: translateY(0);
		padding: 27rem 40rem;
		background-color: #fbfbfb;
		box-shadow: 0 2rem 8rem rgba(0, 0, 0, 0.06);
		border-bottom: 1rem solid #000;
	}
	.sticky-bar-inner {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		position: relative;
	}
	.sticky-title {
		font-size: 16rem;
		font-weight: 500;
		color: #000 !important;
		margin: 0;
		font-family: 'Apercu-Medium', sans-serif;
	}
	.sticky-count {
		font-size: 12rem;
		font-weight: 500;
		color: #000 !important;
		flex-shrink: 0;
		margin-left: 20rem;
		align-self: center;
		font-family: 'Apercu-Medium', sans-serif;
	}
	.sticky-logo {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%) scale(0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		pointer-events: none;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}
	.sticky-logo.logo-visible {
		transform: translate(-50%, -50%) scale(1);
		opacity: 1;
		pointer-events: auto;
	}
	.sticky-logo-img {
		cursor: pointer;
		display: block;
	}
	.content-wrapper {
		max-width: 100%;
		margin: 0 auto;
	}
	.content-spacer {
		/* height controlled by inline style */
	}
	@media (max-width: 768px) {
		.fixed-info-bar {
			top: 74rem;
			padding: 14rem 20rem;
		}
		.sticky-bar {
			padding: 14rem 20rem;
		}
		.sticky-bar.is-visible {
			padding: 14rem 20rem;
		}
		.content-wrapper {
			padding: 0 20rem 33rem 20rem;
		}
		.page-title {
			font-size: 16rem;
			margin: 0 0 16rem 0;
		}
		.page-description {
			font-size: 12rem;
			width: 470rem;
		}
		.product-count {
			font-size: 14rem;
		}
		.sticky-title {
			font-size: 14rem;
		}
		.sticky-count {
			font-size: 12rem;
		}
	}
	@media (max-width: 480px) {
		.fixed-info-bar {
			top: 74rem;
			padding: 12rem 16rem;
		}
		.sticky-bar.is-visible {
			padding: 12rem 16rem;
		}
		.page-title {
			font-size: 16rem;
		}
		.page-description {
			font-size: 12rem;
			width: 470rem;
		}
		.product-count {
			font-size: 12rem;
		}
		.sticky-title {
			font-size: 12rem;
		}
		.sticky-count {
			font-size: 10rem;
		}
	}
</style>